export const environment = {
  production: true,
  domain: '.griddynamics.net',
  measurementId: 'G-KVST3SH4NR'
};
